import React, { useEffect, useRef, useState } from "react";
import MetricToggle from "./MetricToggle";
import HeaderTabSelector from "./HeaderTabSelector";
import ContractorCompliance from "./ContractorCompliance";
import ContractorMainDetails from "./ContractorMainDetails";
import ContractorDocuments from "./ContractorDocuments";


export default function ContractorEditModal(props) {

  var open = props.open;
  var contractor = props.asset;               // existing asset object (or null for new)
  var onClose = props.onClose;

  
  const [activeTab, setActiveTab] = useState('contractor');
 

  useEffect(function () {

    if (!open) {
      return;
    }

   

  }, [open, contractor]);


  if (!open) {
    return null;
  }


  var styles = {
	
	metricRow: {
	  display: "flex",
	  gap: "16px",
	  flexWrap: "nowrap",
	  marginLeft:'20px',
	  marginRight:'20px',
	  marginTop:'10px',
	  width:'calc(100% - 40px)'
	},

    backdrop: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.45)",
      zIndex: 5000
    },

    popup: {
      position: "absolute",
      left: "5%",
      right: "5%",
      top: "90px",
      bottom: "20px",
      background: "linear-gradient(180deg, #FFFFFF 0%, #F3F5F8 100%)",
      borderRadius: "12px",
      boxShadow: "0 18px 70px rgba(0,0,0,0.35)",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column"
    },

    header: {
      padding: "16px 18px",
      borderBottom: "1px solid rgba(0,0,0,0.08)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "linear-gradient(180deg, #FFFFFF 0%, #EEF1F6 100%)"
    },

    headerLeft: {
      display: "flex",
      flexDirection: "column"
    },

    title: {
      fontSize: "18px",
      fontWeight: 700,
      color: "#111"
    },

    sub: {
      fontSize: "12px",
      color: "rgba(0,0,0,0.60)",
      marginTop: "2px"
    },

    closeBtn: {
      width: "36px",
      height: "36px",
      borderRadius: "10px",
      border: "1px solid rgba(0,0,0,0.10)",
      background: "#fff",
      cursor: "pointer",
      fontSize: "18px",
      lineHeight: "34px"
    },

    body: {
      flex: 1,
      display: "flex",
      gap: "14px",
      padding: "14px",
      overflow: "hidden",
      minHeight: 0
    },

    col: {
      background: "#fff",
      borderRadius: "12px",
      border: "1px solid rgba(0,0,0,0.08)",
      boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      minWidth: 0,
      minHeight: 0,
	  margin:'10px'
    },

    colLeft: { flex: 1.05 },
    colRight: { flex: 1.15 , flexDirection:'column'},

    colHeader: {
      padding: "12px 14px",
      borderBottom: "1px solid rgba(0,0,0,0.06)",
      fontWeight: 700,
      fontSize: "13px",
	  background: 'linear-gradient(180deg, rgba(66,133,244,1) 0%, rgba(30,88,182,1) 100%)',
	  color: '#fff'
    },

    section: {
      padding: "12px 14px",
      borderBottom: "1px solid rgba(0,0,0,0.06)"
    },

    sectionTitle: {
      fontSize: "12px",
      fontWeight: 700,
      color: "rgba(0,0,0,0.70)",
      marginBottom: "10px"
    },

    grid2: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "10px"
    },

    field: {
      display: "flex",
      flexDirection: "column"
    },

    label: {
      fontSize: "11px",
      color: "rgba(0,0,0,0.60)",
      marginBottom: "6px",
      fontWeight: 600
    },

    input: {
      padding: "10px 10px",
      borderRadius: "10px",
      border: "1px solid rgba(0,0,0,0.12)",
      outline: "none",
      fontSize: "13px",
      background: "#fff"
    },

    select: {
      padding: "10px 10px",
      borderRadius: "10px",
      border: "1px solid rgba(0,0,0,0.12)",
      outline: "none",
      fontSize: "13px",
      background: "#fff"
    },

    optionRow: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "10px"
    },

    card: {
      border: "1px solid rgba(0,0,0,0.10)",
      borderRadius: "12px",
      padding: "10px 10px",
      cursor: "pointer",
      background: "#fff"
    },

    cardActive: {
      border: "1px solid rgba(31,111,229,0.55)",
      background: "rgba(31,111,229,0.06)",
      boxShadow: "0 8px 18px rgba(31,111,229,0.12)"
    },

    cardTop: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },

    cardLabel: {
      fontWeight: 700,
      fontSize: "13px",
      color: "#111"
    },

    cardHint: {
      fontSize: "11px",
      color: "rgba(0,0,0,0.55)",
      marginTop: "4px"
    },

    pillRow: {
      display: "flex",
      flexWrap: "wrap",
      gap: "8px"
    },

    pill: {
      border: "1px solid rgba(0,0,0,0.12)",
      background: "#fff",
      padding: "8px 10px",
      borderRadius: "999px",
      cursor: "pointer",
      fontSize: "12px",
      fontWeight: 700,
      color: "rgba(0,0,0,0.70)"
    },

    pillActive: {
      border: "1px solid rgba(31,111,229,0.55)",
      background: "linear-gradient(90deg, rgba(31,111,229,0.14), rgba(42,141,247,0.14))",
      color: "#1f6fe5"
    },

    drop: {
      border: "1px dashed rgba(0,0,0,0.12)",
      borderRadius: "12px",
      padding: "12px",
      background: "#fff"
    },

    dropTop: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "10px"
    },

    dropText: {
      fontSize: "12px",
      color: "rgba(0,0,0,0.65)",
      fontWeight: 600
    },

    uploadBtn: {
      border: "1px solid rgba(0,0,0,0.12)",
      background: "#fff",
      borderRadius: "10px",
      padding: "8px 10px",
      cursor: "pointer",
      fontWeight: 700,
      fontSize: "12px"
    },

    thumbGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(4, 1fr)",
      gap: "10px"
    },

    thumb: {
      position: "relative",
      borderRadius: "12px",
      overflow: "hidden",
      border: "1px solid rgba(0,0,0,0.10)",
      height: "74px",
      background: "#f3f5f8"
    },

    thumbImg: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    },

    thumbX: {
      position: "absolute",
      top: "6px",
      right: "6px",
      width: "22px",
      height: "22px",
      borderRadius: "8px",
      border: "1px solid rgba(0,0,0,0.10)",
      background: "rgba(255,255,255,0.95)",
      cursor: "pointer",
      fontWeight: 900,
      lineHeight: "20px",
      textAlign: "center"
    },

    textarea: {
      width: "100%",
      minHeight: "110px",
      resize: "vertical",
      padding: "10px 10px",
      borderRadius: "12px",
      border: "1px solid rgba(0,0,0,0.12)",
      outline: "none",
      fontSize: "13px"
    },

    footer: {
      padding: "14px 18px",
      borderTop: "1px solid rgba(0,0,0,0.08)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      background: "#fff"
    },

    footLeft: {
      fontSize: "12px",
      color: "rgba(0,0,0,0.60)"
    },

    btnRow: {
      display: "flex",
      gap: "10px",
      alignItems: "center"
    },

    btnCancel: {
      border: "1px solid rgba(0,0,0,0.16)",
      background: "#fff",
      borderRadius: "10px",
      padding: "10px 14px",
      cursor: "pointer",
      fontWeight: 700
    },

    btnSave: {
      border: "none",
      background: "linear-gradient(90deg, #1f6fe5, #2a8df7)",
      color: "#fff",
      borderRadius: "10px",
      padding: "10px 16px",
      cursor: "pointer",
      fontWeight: 800,
      boxShadow: "0 12px 26px rgba(31,111,229,0.25)"
    },
	
	modalBody: {
	    position: "relative",
	    overflow: "hidden",
	    flex: 1,
	    background: "#f5f7fa"
	  },

	  slider: {
	    display: "flex",
	    width: "300%",
	    height: "100%",
	    transition: "transform 0.35s ease"
	  },

	  panel: {
	    width: "33.33%",
	    padding: "10px",
	    overflowY: "auto"
	  },
	  
	  colWrap: {
		display:'flex',
		flexDirection:'row'
	  }
  };

  return (
    <div style={styles.backdrop}>
      <div style={styles.popup}>

        {/* HEADER */}
        <div style={styles.header}>
          <div style={styles.headerLeft}>
            <div style={styles.title}>Contractor/Supplier Profile</div>
            <div style={styles.sub}>
              Assign details to authorised contractor/supplier
            </div>
          </div>

          <div style={styles.headerCenter}>
            <HeaderTabSelector
              tabs={[
                { key: "contractor", label: "Details" },
                { key: "compliance", label: "Compliance" },
                { key: "documents", label: "Documents" }
              ]}
              activeTab={activeTab}
              onChange={setActiveTab}
            />
          </div>

          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>

        {/* BODY */}
        <div style={styles.modalBody}>
		<div
		  style={{
		    ...styles.slider,
		    transform:
		      activeTab === "contractor"
		        ? "translateX(0%)"
		        : activeTab === "compliance"
		        ? "translateX(-33.3333%)"
		        : "translateX(-66.6666%)"
		  }}
		>

            {/* ================= ASSET PANEL ================= */}
            <div style={styles.panel}>
			<div style={{width:'100%', height:'100%', backgroundColor:'white', color:'black'}}>
			  	<ContractorMainDetails />
			  </div>
            </div>

            {/* ================= COMPLIANCE PANEL ================= */}
            <div style={styles.panel}>
              <div style={{width:'100%', height:'100%', backgroundColor:'black', color:'white'}}>
			  	<ContractorCompliance />
			  </div>
            </div>
			
			{/* ================= DOCUMENTS PANEL ================= */}
            <div style={styles.panel}>
              <div style={{width:'100%', height:'100%', backgroundColor:'white', color:'black'}}>
			  	<ContractorDocuments />
			  </div>
            </div>

          </div>
        </div>

        {/* FOOTER */}
        <div style={styles.footer}>
          <div style={styles.footLeft}>
            Changes are local until you hit Save
          </div>

          <div style={styles.btnRow}>
            <button style={styles.btnCancel} onClick={onClose}>
              Cancel
            </button>
            <button style={styles.btnSave} onClick={onClose}>
              Save Asset
            </button>
          </div>
        </div>

      </div>
    </div>
  );

}
